import modelConfig from './model/config';

const modelsConfig = {
  exampleModel: modelConfig
};

export default modelsConfig;